/**
 * Custom hook to sync bank details with Redux store
 * Uses hydrateDisBankState for efficient bulk updates
 */

import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { hydrateDisBankState } from "../../../features/distributor/bank";

export interface BankDetails {
  bankName: string;
  accountNumber: string;
  accountType: string;
  swiftCode: string;
  accountHolderName: string;
  bankAddress: string;
  bankCountry: string;
  currency: string;
}

/**
 * Hook to sync bank details to Redux store
 * Uses hydrateDisBankState to update all fields in a single dispatch
 */
export const useBankReduxSync = () => {
  const dispatch = useDispatch();

  const syncBankDetails = useCallback(
    (details: BankDetails) => {
      dispatch(hydrateDisBankState(details));
    },
    [dispatch]
  );

  return { syncBankDetails };
};
